export const defaultAttr = {
  jobTitle: {
    internal: true,
    external: true,
    disabled: true,
    label: 'Job Title',
  },
  jobCompensation: {
    internal: true,
    external: false,
    disabled: false,
    label: 'Compensation',
  },
  jobCode: {
    internal: true,
    external: true,
    disabled: true,
    label: 'Job Code',
  },
  jobLocation: {
    internal: true,
    external: true,
    disabled: true,
    label: 'Job Location',
  },
  jobPosition: {
    internal: true,
    external: true,
    disabled: false,
    label: 'Positions',
  },
  jobSkills: {
    internal: true,
    external: true,
    disabled: true,
    label: 'Skills',
  },
  jobDescription: {
    internal: true,
    external: true,
    disabled: true,
    label: 'Job Description',
  },
  jobType: {
    internal: true,
    external: true,
    disabled: true,
    label: 'Job Type',
  },
  jobCompanyName: {
    internal: true,
    external: true,
    disabled: false,
    label: 'Company Name',
  },
  jobCompanyRecruiter: {
    internal: true,
    external: false,
    disabled: false,
    label: 'Company Recruiter',
  },
  jobTags: {
    internal: true,
    external: false,
    disabled: false,
    label: 'Tags',
  },
  jobClientJobCode: {
    internal: true,
    external: false,
    disabled: false,
    label: 'Client Job Code',
  },
  jobAccountManager: {
    internal: true,
    external: false,
    disabled: false,
    label: 'Account Manager',
  },
  jobInsight: {
    internal: true,
    external: true,
    disabled: false,
    label: 'Job Insights',
  },
  jobSubmission: {
    internal: true,
    external: true,
    disabled: false,
    label: 'Candidate Submission',
  },
  jobMapping: {
    internal: true,
    external: true,
    disabled: false,
    label: 'Candidate Mapping',
  },
  jobAssignedRecruiters: {
    internal: false,
    external: false,
    disabled: false,
    label: 'Assigned Recruiters',
  },
  jobActiveRecruiters: {
    internal: false,
    external: false,
    disabled: false,
    label: 'Active Recruiters',
  },
};
export const getDefaultJobAttr = () => {
  return defaultAttr;
};
